<app-title-section></app-title-section>

<div class="card p-1 facture-consolid-page" style="margin-left: 15px; margin-right: 15px; min-height: 70vh;">
  <div class="d-flex flex-wrap justify-content-between align-items-start gap-2 px-2 pt-2">
    <div>
      <p class="mb-1" style="font-size: 18px; font-weight: 600; color: #2f2b3de5;">
        Traçabilité des tickets
      </p>
      <p class="text-muted mb-0" style="font-size: 14px;">
        Facture ERP
        <strong *ngIf="factureCode">{{ factureCode }}</strong>
        <span *ngIf="!factureCode">#{{ factureId }}</span>
        — tickets consolidés liés
      </p>
    </div>
    <button type="button" class="btn btn-outline-primary btn-sm" (click)="goBack()">
      Retour
    </button>
  </div>

  <div class="table-responsive mt-3 px-1">
    <table class="table table-hover mb-0 align-middle">
      <thead>
        <tr>
          <th>Numéro ticket</th>
          <th>Date</th>
          <th>Type</th>
          <th>Établissement</th>
          <th>Statut</th>
          <th>Paiement</th>
          <th>Client</th>
          <th class="text-end">Total</th>
        </tr>
      </thead>

      <tbody *ngIf="loading">
        <tr *ngFor="let _ of skeletonRows" class="erp-table-skeleton__row">
          <td><span class="erp-table-skeleton__cell"></span></td>
          <td><span class="erp-table-skeleton__cell erp-table-skeleton__cell--sm"></span></td>
          <td><span class="erp-table-skeleton__cell erp-table-skeleton__cell--sm"></span></td>
          <td><span class="erp-table-skeleton__cell"></span></td>
          <td><span class="erp-table-skeleton__cell erp-table-skeleton__cell--sm"></span></td>
          <td><span class="erp-table-skeleton__cell erp-table-skeleton__cell--sm"></span></td>
          <td><span class="erp-table-skeleton__cell"></span></td>
          <td><span class="erp-table-skeleton__cell erp-table-skeleton__cell--sm"></span></td>
        </tr>
      </tbody>

      <tbody *ngIf="!loading && tickets.length">
        <tr *ngFor="let t of tickets">
          <td><span class="fw-semibold" style="color: #2f2b3de5;">{{ t.numero }}</span></td>
          <td>{{ t.dateLabel }}</td>
          <td>
            <span class="badge" [class.badge-consolide]="t.consolide" [class.badge-ticke]="!t.consolide">
              {{ t.typeLabel }}
            </span>
          </td>
          <td>{{ t.entrepot }}</td>
          <td>{{ t.statut }}</td>
          <td>{{ t.paiement }}</td>
          <td style="white-space: pre-line;">{{ t.client }}</td>
          <td class="text-end fw-semibold">{{ t.totalLabel }}</td>
        </tr>
      </tbody>
    </table>

    <div *ngIf="!loading && !tickets.length" class="text-center py-5">
      <p class="mt-2 mb-0" style="color: #2f2b3db3; font-size: 15px;">
        Aucun ticket consolidé lié à cette facture.
      </p>
    </div>
  </div>
</div>
